import React from "react";
import { useAuthModal } from "./AuthModal";

type Props = React.AnchorHTMLAttributes<HTMLAnchorElement> & {
  mode?: "login" | "register";
  /** Where to go after signing in; by default the user stays on the current page. */
  next?: string;
};

/**
 * A real link to /login or /register (so opening it in a new tab still works) that opens
 * the sign-in modal in place on a plain click.
 */
const AuthLink = React.forwardRef<HTMLAnchorElement, Props>(({ mode = "login", next, onClick, children, ...props }, ref) => {
  const { openLogin, openRegister } = useAuthModal();
  return (
    <a
      ref={ref}
      href={`/${mode}`}
      {...props}
      onClick={e => {
        onClick?.(e);
        if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
        e.preventDefault();
        (mode === "register" ? openRegister : openLogin)({ next });
      }}
    >
      {children}
    </a>
  );
});
AuthLink.displayName = "AuthLink";

export default AuthLink;
